// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"43afb820","280":"e9d5f697","439":"2828f54d","476":"43afb820","508":"b49deb63","511":"1d45eaee","543":"3807d0e9","586":"1c9247cb","722":"74f3eccb"}[chunkId] + ".chunk.css";
};